<h1 class="common-section-title">{{ lg.servicesBlock.heading }}</h1>
<div class="common-container">
  <div class="common-section-wrapper">
    @for (service of services; track service) {
      <bmcore-service-item [service]="service"></bmcore-service-item>
    }
  </div>
</div>
